import adminApi from "./adminApi";


export async function copyDatabase(from, to) {

  const response = await adminApi.post(
    "/dbmgr/copy",
    {
      from,
      to,
    },
    {
      headers: {
        "x-admin-key": process.env.REACT_APP_ACCESKEY,
      },
    }
  );


  return response.data;
}

export async function getDatabases() {
  const response = await adminApi.get("/dbmgr/databases", {
    headers: {
      "x-admin-key": process.env.REACT_APP_ACCESKEY,
    },
  });

  return response.data;
}

export async function backupDatabase(database) {
  const response = await adminApi.post(
    "/dbmgr/backup",
    { database },
    {
      headers: {
        "x-admin-key": process.env.REACT_APP_ACCESKEY,
      },
    }
  );

  return response.data;
}

export async function getBackups(database) {
  const response = await adminApi.get(
    `/dbmgr/backups/${database}`,
    {
      headers: {
        "x-admin-key": process.env.REACT_APP_ACCESKEY,
      },
    }
  );

  return response.data;
}

export async function restoreDatabase(database, backup) {
  const response = await adminApi.post(
    "/dbmgr/restore",
    {
      database,
      backup,
    },
    {
      headers: {
        "x-admin-key": process.env.REACT_APP_ACCESKEY,
      },
    }
  );

  return response.data;
}